import axios from "axios";

export const isCoupon = async (coupon_code, almond_pin) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/api/user/isCoupon`,
      { coupon_code, almond_pin }
    );
    return response;
  } catch (err) {
    return err.response;
  }
};
